var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "step",
    {
      attrs: {
        title: "Review Type",
        description: _vm.description,
        id: "process",
        component: _vm.component,
      },
    },
    [
      _c(
        "div",
        { staticClass: "flex-grow flex flex-col" },
        [
          _c(
            "toolbar",
            [
              _c("div", { staticClass: "flex-grow" }),
              _vm._v(" "),
              _c("step-pager", {
                staticClass: "my-1",
                attrs: { disabled: !_vm.isValid },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "grid grid-cols-4 gap-4 pt-4 pb-8 px-4 flex-grow" },
            [
              _c(
                "div",
                [
                  _c("review-product-selector", {
                    staticClass: "pb-4",
                    attrs: {
                      "field-class": "pb-4 w-112",
                      "required-fields": "review-type",
                      "only-import-process": _vm.onlyImportProcess,
                      "is-exception": _vm.isException,
                      validations: _vm.showValidations ? _vm.validations : null,
                      "verification-token": _vm.verificationToken,
                      disabled: _vm.reviewOrderId != null,
                      clearable: "",
                    },
                    on: {
                      "import-process-id": function ($event) {
                        _vm.importProcessId = $event
                      },
                      "review-type": function ($event) {
                        _vm.reviewType = $event
                      },
                      "review-vendor": function ($event) {
                        _vm.reviewVendor = $event
                      },
                      "review-product": function ($event) {
                        _vm.reviewProduct = $event
                      },
                    },
                    model: {
                      value: _vm.reviewModel,
                      callback: function ($$v) {
                        _vm.reviewModel = $$v
                      },
                      expression: "reviewModel",
                    },
                  }),
                  _vm._v(" "),
                  _c("package-selector", {
                    attrs: {
                      status: "Bid|Won|Pending Settle|Indication|Funded",
                      "field-class": "pb-4 w-112",
                      "has-loans": true,
                      validations: _vm.showValidations ? _vm.validations : null,
                      "verification-token": _vm.verificationToken,
                      disabled: _vm.reviewOrderId != null,
                      clearable: "",
                    },
                    on: {
                      package: function ($event) {
                        _vm.package = $event
                      },
                      buyer: function ($event) {
                        _vm.buyer = $event
                      },
                      seller: function ($event) {
                        _vm.seller = $event
                      },
                    },
                    model: {
                      value: _vm.packageModel,
                      callback: function ($$v) {
                        _vm.packageModel = $$v
                      },
                      expression: "packageModel",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _vm.reviewOrderDataSource !== null
                ? _c(
                    "div",
                    { staticClass: "mt-6 flex flex-col col-span-3" },
                    [
                      _c(
                        "grid",
                        {
                          key: _vm.orderGridKey,
                          ref: "reviewOrderGrid",
                          staticClass: "flex-grow",
                          attrs: {
                            "data-source": _vm.reviewOrderDataSource,
                            "get-row-id": _vm.getRowId,
                          },
                          on: {
                            "selection-changed": function ($event) {
                              return _vm.onReviewOrderChanged($event)
                            },
                            "row-double-clicked":
                              _vm.onReviewOrderRowDoubleClick,
                            "grid-ready": _vm.onGridReady,
                          },
                        },
                        [
                          _c("grid-column", {
                            attrs: {
                              "checkbox-selection": true,
                              "header-name": "",
                              "suppress-header-menu-button": true,
                              sortable: false,
                              pinned: "left",
                              width: 35,
                            },
                          }),
                          _vm._v(" "),
                          _c("grid-column", {
                            attrs: {
                              field: "createdDate",
                              "header-name": "Date Ordered",
                              type: "date",
                              "date-format": "MM/dd/yyyy",
                              filter: "agDateColumnFilter",
                              "floating-filter": true,
                              "filter-params": {
                                alwaysShowBothConditions: true,
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("grid-column", {
                            attrs: {
                              field: "finalDueDate",
                              "header-name": "Final Due Date",
                              type: "date",
                              "date-format": "MM/dd/yyyy",
                              filter: "agDateColumnFilter",
                              "floating-filter": true,
                              "filter-params": {
                                alwaysShowBothConditions: true,
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("grid-column", {
                            attrs: {
                              field: "currentStatus",
                              "header-name": "Status",
                              filter: "agTextColumnFilter",
                              "floating-filter": true,
                            },
                          }),
                          _vm._v(" "),
                          _c("grid-column", {
                            attrs: {
                              field: "loanCount",
                              "header-name": "Loan Count",
                              format: "n0",
                              filter: "agNumberColumnFilter",
                              "floating-filter": true,
                            },
                          }),
                          _vm._v(" "),
                          _c("grid-column", {
                            attrs: {
                              field: "clientRefId",
                              "header-name": "Customer Reference ID",
                              filter: "agTextColumnFilter",
                              "floating-filter": true,
                            },
                          }),
                          _vm._v(" "),
                          _c("grid-column", {
                            attrs: {
                              field: "reviewType",
                              "header-name": "Review Type",
                              filter: "agTextColumnFilter",
                              "floating-filter": true,
                            },
                          }),
                          _vm._v(" "),
                          _c("grid-column", {
                            attrs: {
                              field: "organizationName",
                              "header-name": "Vendor",
                              filter: "agTextColumnFilter",
                              "floating-filter": true,
                            },
                          }),
                          _vm._v(" "),
                          _c("grid-column", {
                            attrs: {
                              field: "productType",
                              "header-name": "Product",
                              filter: "agTextColumnFilter",
                              "floating-filter": true,
                            },
                          }),
                          _vm._v(" "),
                          _c("grid-column", {
                            attrs: {
                              field: "buyerName",
                              "header-name": "Buyer Name",
                              filter: "agTextColumnFilter",
                              "floating-filter": true,
                            },
                          }),
                          _vm._v(" "),
                          _c("grid-column", {
                            attrs: {
                              field: "sellerName",
                              "header-name": "Seller Name",
                              filter: "agTextColumnFilter",
                              "floating-filter": true,
                            },
                          }),
                          _vm._v(" "),
                          _c("grid-column", {
                            attrs: {
                              field: "packageName",
                              "header-name": "Package",
                              filter: "agTextColumnFilter",
                              "floating-filter": true,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }